/**
 * fantasyArt — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const fantasyArtPack: ToilePack = {
    slug: 'fantasy-art',
    category: 'creatures',
    name: 'Fantasy creatures',
    tagline: tagline('pieces', 'creatures', 'styles'),
    chips: chips('creatures', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'dragon', label: 'Dragon', subject: 'a horned dragon on a shattered spire, smoke curling from its jaws'},
        {key: 'phoenix', label: 'Phoenix', subject: 'a phoenix rising from embers, tail feathers streaming into flame'},
        {key: 'serpent', label: 'Sea serpent', subject: 'a sea serpent breaching from a green swell, barnacled fins'},
    ],
    styles: [
        {key: 'epic', label: 'Epic painted', style: 'cinematic digital oil painting, finely rendered', palette: 'dramatic rim light, rich color', framing: 'tall vertical, the creature whole'},
        {key: 'celtic', label: 'Celtic ornament', style: 'the body woven into interlaced knotwork', palette: 'flat gold and deep green on vellum', framing: 'tall vertical, a circular border'},
        {key: 'ink', label: 'Dark ink', style: 'brush and pen, aggressive hatching, spot blacks', palette: 'black on white, high contrast', framing: 'tall vertical, the creature whole'},
    ],
    directions: ['a griffin instead', 'in moonlight over snow', 'as a young hatchling'],
}
